export default (value: string): string => (value || '').replace(/<img .*?>/g, '');
